import { AreaKey } from '@/types/area';
import { UrlParamKey, getUrlParamByKey } from '@/utils/url-params-helper';
import { defineStore } from 'pinia';
import { useConfigStore } from './config';
import { i18n } from '@/i18n';

const CROSS_TRAVEL_AREA = 'CROSS_TRAVEL_AREA';

export const useLocationStore = defineStore('location', {
  state: () => ({
    area: getDefaultArea(),
  }),
  getters: {
    currentArea: state => state.area,
  },
  actions: {
    setArea(area: AreaKey) {
      setDefaultArea(area || this.area);
      updateTitle(area);
      this.area = area;
    },
  },
});

/**
 * 更新title
 * @param area
 */
function updateTitle(area: AreaKey) {
  let title: string;

  switch (area) {
    case AreaKey.Japan:
      title = i18n('日本遊');
      break;
    case AreaKey.Macao:
      title = i18n('澳門遊');
      break;
    default:
      title = i18n('內地遊');
      break;
  }
  document.title = title;
}

/**
 * 获取默认的区域
 * 1. url 中的 area 参数获取
 * 2. 本地 sessionStorage 中获取
 * 3. 默认为中国内地
 */
function getDefaultArea() {
  const area = getUrlParamArea() || sessionStorage.getItem(CROSS_TRAVEL_AREA) || AreaKey.MainLand;
  updateTitle(area as AreaKey);
  return area;
}

function setDefaultArea(area) {
  sessionStorage.setItem(CROSS_TRAVEL_AREA, area);
}

/** 获取 url 中 area 值 */
function getUrlParamArea() {
  const area = getUrlParamByKey(UrlParamKey.area);
  if (!area || !isValidAreaKey(area)) return '';
  return area;
}
/** 是否是合法的区域 */
function isValidAreaKey(key: string) {
  return useConfigStore().areaKeyList.includes(key);
}
